"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../../hooks");

var _components = require("../../../../components");

var _MarketInfoModule = _interopRequireDefault(require("./MarketInfo.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var MarketInfo = function MarketInfo(_ref) {
  var cellType = _ref.cellType,
      bannerLogo = _ref.bannerLogo,
      bannerTitle = _ref.bannerTitle,
      bannerDesc = _ref.bannerDesc,
      onSeeFullMenu = _ref.onSeeFullMenu;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    className: _MarketInfoModule["default"]["banner-info"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _MarketInfoModule["default"]["banner-info-logo"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundImage: "url(".concat(bannerLogo, ")")
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _MarketInfoModule["default"]["banner-info-content"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, " ", bannerTitle), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, " ", bannerDesc), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons === null || buttons === void 0 ? void 0 : buttons.primary,
    onClick: onSeeFullMenu
  }, "SEE FULL MENU")));
};

var _default = MarketInfo;
exports["default"] = _default;